var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vheader-menu" }, [
    _c(
      "div",
      {
        staticClass: "vheader-menu-item vheader-menu-item-profile",
        on: {
          mouseover: function ($event) {
            _vm.showProfileMenu = true
          },
          mouseleave: function ($event) {
            _vm.showProfileMenu = false
          },
        },
      },
      [
        _vm.userName ? _c("span", { staticClass: "lnr lnr-user" }) : _vm._e(),
        _vm._v(" "),
        _vm.userName
          ? _c(
              "span",
              { staticClass: "vheader-menu-item-profile__user-name" },
              [_vm._v("\n            " + _vm._s(_vm.userName) + "\n        ")]
            )
          : _c("div", { on: { click: _vm.showSignin } }, [_vm._v("Войти")]),
        _vm._v(" "),
        _vm.showProfileMenu && _vm.userName
          ? _c("div", { staticClass: "vheader-menu-item-submenu" }, [
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.redirect("/profile")
                    },
                  },
                },
                [_c("a", { attrs: { href: "/profile" } }, [_vm._v("Профиль")])]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  on: {
                    click: function ($event) {
                      return _vm.redirect("/signout")
                    },
                  },
                },
                [_c("a", { attrs: { href: "/signout" } }, [_vm._v("Выход")])]
              ),
            ])
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "vheader-menu-item vheader-menu-item-burger",
        on: {
          mouseover: function ($event) {
            _vm.showBurgerMenu = true
          },
          mouseleave: function ($event) {
            _vm.showBurgerMenu = false
          },
        },
      },
      [
        _c("i", { staticClass: "uk-icon-th uk-icon-small" }),
        _vm._v(" "),
        _vm.showBurgerMenu
          ? _c(
              "div",
              {
                staticClass:
                  "vheader-menu-item-submenu vheader-menu-item-burger-submenu",
              },
              [
                _vm.userName
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "router-link-fallback",
                            rawName: "v-router-link-fallback",
                          },
                        ],
                        attrs: { href: "/search" },
                      },
                      [_vm._v("Подбор клиентов")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userName
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "router-link-fallback",
                            rawName: "v-router-link-fallback",
                          },
                        ],
                        attrs: { href: "/monitoring" },
                      },
                      [
                        _vm._v("\n                Мониторинг ЮЛ/ИП"),
                        _vm.allCountUnseen
                          ? _c(
                              "i",
                              { staticClass: "monitoring-notification" },
                              [_vm._v(_vm._s(_vm.allCountUnseen))]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userName
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "router-link-fallback",
                            rawName: "v-router-link-fallback",
                          },
                        ],
                        attrs: { href: "/monitoring-fl" },
                      },
                      [_vm._v("Мониторинг сотрудников")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.userName
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "router-link-fallback",
                            rawName: "v-router-link-fallback",
                          },
                        ],
                        staticClass: "beta",
                        attrs: { href: "/relations-search" },
                      },
                      [_vm._v("Поиск связей")]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }